import { usePathname } from 'next/navigation'

export const useSlugnifier = () => {
  const pathname = usePathname()
  const slugSegments = pathname.split('/').filter((segment) => segment !== '')
  const first = slugSegments?.[0]
  const last = slugSegments[slugSegments.length - 1]
  return {
    slugs: slugSegments,
    first,
    last,
  }
}
